const finiteCount = (value) => {
  if (value == null || value === "") return null;
  const count = Number(value);
  return Number.isFinite(count) && count >= 0 ? count : null;
};

export function resolveMergedCount({ nextCount, previousCount, fallbackLength = 0, hasNextDetail = false }) {
  // An explicit total is authoritative, even when zero or smaller than a
  // previously loaded array. A missing total is different from a zero total.
  const next = finiteCount(nextCount);
  if (next != null) return next;
  if (hasNextDetail) return finiteCount(fallbackLength) ?? 0;
  return finiteCount(previousCount) ?? finiteCount(fallbackLength) ?? 0;
}

export const COMPANY_RELATIONSHIPS_CHANGED = "rpo:company-relationships-changed";

export function subscribeCompanyRelationshipsChanged(refresh) {
  const onStorage = (event) => {
    if (event.key === COMPANY_RELATIONSHIPS_CHANGED) refresh();
  };
  window.addEventListener(COMPANY_RELATIONSHIPS_CHANGED, refresh);
  window.addEventListener("storage", onStorage);
  window.addEventListener("focus", refresh);
  return () => {
    window.removeEventListener(COMPANY_RELATIONSHIPS_CHANGED, refresh);
    window.removeEventListener("storage", onStorage);
    window.removeEventListener("focus", refresh);
  };
}

export function notifyCompanyRelationshipsChanged() {
  window.dispatchEvent(new Event(COMPANY_RELATIONSHIPS_CHANGED));
  try {
    // Also invalidate an already-open Companies table in another browser tab.
    localStorage.setItem(COMPANY_RELATIONSHIPS_CHANGED, `${Date.now()}:${Math.random()}`);
  } catch {
    // Local notifications still work when browser storage is unavailable.
  }
}
